import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'zone.js';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';

import 'leaflet';
import { isLocal } from '@bazis/utils';

if (environment.production) {
    enableProdMode();
    if (window) {
        //window.console.log = () => {};
    }
}

// if (!isLocal()) {
//     Sentry.init({
//         dsn: 'https://1179b091d4464ef7ba0910b37ea27429@o4505011544260608.ingest.sentry.io/4505447295025152',
//         environment: environment.production ? 'production' : 'development',
//         integrations: [],
//
//         // Set tracesSampleRate to 1.0 to capture 100%
//         // of transactions for performance monitoring.
//         // We recommend adjusting this value in production
//         tracesSampleRate: 0.05,
//
//         // Capture Replay for 10% of all sessions,
//         // plus for 100% of sessions with an error
//         replaysSessionSampleRate: 0.1,
//         replaysOnErrorSampleRate: 1.0,
//
//         initialScope: {
//             tags: {
//                 host: document.location.host,
//             },
//         },
//     });
// }

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.log(err));
